export const PERMISSION_ABILITIES = {
  view: 'view',
  edit: 'edit',
  delete: 'delete',
  approve: 'approve',
};

export const AUDIT_LOG_NAMES = {
  EVENT_VIEWED_BACK: 'eventViewedBack',
  EVENT_RAN_BACK: 'eventRanBack',
  EVENT_RUN: 'researchEventRun',
  EVENT_CREATED: 'ResearchEventCreated',
  EVENT_UPDATED: 'ResearchEventUpdated',
  EVENT_SIGNED: 'ResearchEventRunSigned',
  PROJECT_CREATED: 'ResearchProjectCreated',
  PROJECT_UPDATED: 'ResearchProjectUpdated',
  PROJECT_DELETED: 'ProjectDeleted',
  PIPELINE_CREATED: 'ResearchPipelineCreated',
  PIPELINE_APPROVED: 'ResearchPipelineSigned',
  ROLE_CREATED: 'ResearchRoleCreated',
  ROLE_UPDATED: 'ResearchRoleUpdated',
  ROLE_DELETED: 'ResearchRoleDeleted',
  REPOSITORY_MEMBER_INVITED: 'ResearchRepositoryMemberInvitationSent',
  REPOSITORY_MEMBER_ACTIVE: 'ResearchRepositoryMemberActive',
  REPOSITORY_MEMBER_CREATED: 'ResearchRepositoryMemberCreated',
  REPOSITORY_MEMBER_APPROVED: 'ResearchRepositoryMemberApproved',
  REPOSITORY_SITE_CREATED: 'ResearchRepositorySiteCreated',
  REPOSITORY_SITE_DELETED: 'ResearchRepositorySiteDeleted',
  REPOSITORY_SITE_UPDATED: 'ResearchRepositorySiteUpdated',
  RESULT_VIEW_CREATED: 'ResearchResultsViewCreated',
  RESULT_VIEW_UPDATED: 'ResearchResultsViewUpdated',
  RESULT_VIEW_DELETED: 'ResearchResultsViewDeleted',
  PROJECT_MEMBER_INVITED: 'ResearchProjectMemberInvitationSent',
  PROJECT_MEMBER_REJECTED: 'ResearchProjectMemberRejected',
  PROJECT_MEMBER_DELETED: 'ResearchProjectMemberDeleted',
  PROJECT_MEMBER_APPROVED: 'ResearchProjectMemberApproved',
  PROJECT_MEMBER_ACTIVATED: 'ResearchProjectMemberActive',
  PROJECT_MEMBER_REACTIVATED: 'ResearchProjectMemberActivated', // TODO: This one should be removed in BE. It triggers when activating a deactivated member, while PROJECT_MEMBER_ACTIVATED triggers on first activation (approval of the member)
  PROJECT_MEMBER_DEACTIVATED: 'ResearchProjectMemberDeactivated',
  PROJECT_MEMBER_ROLE_ASSIGNED: 'ResearchProjectMemberRoleAssigned',
  PROJECT_MEMBER_CREATED: 'ResearchProjectMemberCreated',
  SUBJECT_CREATED: 'ResearchSubjectCreated',
  SUBJECT_UPDATED: 'ResearchSubjectUpdated',
  FORM_CREATED: 'ResearchFormCreated',
  FORM_UPDATED: 'ResearchFormUpdated',
  FORM_APPROVED: 'ResearchFormApproved',
  FORM_DELETED: 'ResearchFormDeleted',
  RESULT_OVERRIDDEN: 'ResearchResultEntryDataOverrideCreated',
};

export const RESEARCH_AUDIT_LOG_NAMES = {
  EVENT_RUN: 'eventRan',
};

export const FORM_FIELD_TYPES = {
  multiselect: 'multiselect',
  number: 'number',
  slider: 'slider',
  radio: 'radio',
  text: 'text',
};

export const MEMBERS_INITIAL_FILTERS = {
  activation: null,
  siteId: null,
  status: [],
  name: null,
  role: null,
};

export const ResearchProjectMembersPageName = 'ResearchProjectMembersPage';

export const TASKLIST_ACTION_ICONS = {
  runIcon: 'fa-duotone fa-forward fa-swap-opacity',
  rerunIcon: 'fa-duotone fa-redo fa-swap-opacity',
  viewIcon: 'fa-duotone fa-binoculars',
  lockIcon: 'fa fa-lock fa-shake',
};

export const PIPELINE_ENVIRONMENTS = {
  live: 'live',
  design: 'design',
};

export const PROJECT_STATUS = {
  CLOSED: 'CLOSE',
  OPEN: 'OPEN',
};

export const EVENT_MODULE_TYPES = {
  SEGMENTATION: 'segmentation',
  UPLOAD: 'upload',
  DICOM: 'dicom',
  FORM: 'form',
  // TODO: complete the enum
};

export const SPA_ROUTES = {
  REPOSITORY_DASHBOARD: '/research/repository/{repositoryUuid}/projects',
};

export const RESEARCH_FORMS_VERSIONS = {
  ALL: 'all',
  LATEST: 'latest',
};

export const RESEARCH_REPORTS_STATUS = {
  CREATED: 'created',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING_APPROVAL: 'pending_approval',
};

export const RESEARCH_REPORTS_NUMBER_OF_QC_MEMBERS_TO_SHOW = 5;

export const RESEARCH_RESULTS_ENTRY_TYPES = {
  ENTRY: 'entry',
  STAGE: 'stage',
  MEASUREMENT: 'measurement',
};

export const RESEARCH_PREVIOUS_REPORT_STILL_PROCESSING = 'previous report still processing';

export const RESEARCH_PREVIOUS_REPORT_STILL_PROCESSING_STATUS_CODE = 'status code 422';

export const USER_NOTIFICATION_EVENTS_PAYLOAD = {
  email: 'emailChannel',
  webApp: 'webChannel',
  mobile: 'mobileChannel',
};

export const MODELS_CLASS_NAMES = {
  RESEARCH_SEGMENTATION_INSTANCE: 'App\\Models\\ResearchSegmentationInstance',
  RESEARCH_TOOL_INSTANCE: 'App\\Models\\ResearchToolInstance',
  RESEARCH_ATTACHMENT: 'App\\Models\\ResearchAttachment',
  FORM_INSTANCE: 'App\\Models\\FormInstance',
  DICOM_CASE: 'App\\Models\\DicomCase',
};

export const RESEARCH_MERGE_ERROS = {
  NOT_SAME_PATIENT: 'Series do not belong to the same patient',
};

export const RESEARCH_RESULTS_LAYOUTS = {
  TALL_AND_SKINNY: 'tall_skinny',
  SHORT_AND_FAT: 'short_fat',
};

export const RESEARCH_ELECTRONIC_SIGNATURES_ERRORS = {
  INVALID_SIGNATURE: 'Invalid electronic signature',
  GENERIC_ERROR: 'An error occurred while processing the electronic signature',
};

export const RESEARCH_PROJECT_MEMBERS_APPROVAL_ACTIONS = {
  approve: 'approve',
  reject: 'reject',
};

export const INPUT_TEXT_EVENTS_TYPES = {
  INSERT_FROM_PASTE: 'insertFromPaste',
  INSERT_FROM_DROP: 'insertFromDrop',
  INSERT_TEXT: 'insertText',
  DELETE_CONTENT_BACKWARD: 'deleteContentBackward',
  DELETE_CONTENT_FORWARD: 'deleteContentForward',
  HISTORY_UNDO: 'historyUndo',
  HISTORY_REDO: 'historyRedo',
};

export const RESEARCH_PIPELINE_ERRORS = {
  EVENT_QC_IN_USE: 'because it is a QC event and already in use',
};
